import { AnalysisConfigField } from "../models/AnalysisConfigField";
import { AnalysisConfigFieldType } from "../models/AnalysisConfigFieldType";

export type AnalysisConfigJsonEditorType = 'object' | 'array' | 'string' | 'number' | 'integer' | 'boolean' | 'null';

export type AnalysisConfigJsonEditorSchema = {
    type?: AnalysisConfigJsonEditorType;
    properties: any;
    additionalProperties: boolean;
    minProperties?: number;
    not?: any;
    required?: Array<string>;
};

export class AnalysisConfigJsonConfigurationService {

    public static getJsonEditorSchemaForField(field: AnalysisConfigField): AnalysisConfigJsonEditorSchema {
        if (field == null) throw new Error("field is required!");

        const schema: any = {
            properties: {},
            additionalProperties: true
        };

        const schemaType: AnalysisConfigJsonEditorType | null = this.getSchemaTypeForFieldType(field.field_type);
        if (schemaType !== null) {
            schema.type = schemaType;
        }

        return schema;
    }

    private static getSchemaTypeForFieldType(fieldType: AnalysisConfigFieldType | any): AnalysisConfigJsonEditorType | null {

        switch (fieldType) {
            case AnalysisConfigFieldType.Text:
                return 'string';
            case AnalysisConfigFieldType.Number:
                return 'number';
            case AnalysisConfigFieldType.Boolean:
                return 'boolean';
            case AnalysisConfigFieldType.Array:
            case AnalysisConfigFieldType.ArrayValues:
                return 'array';
            case AnalysisConfigFieldType.Object:
            case AnalysisConfigFieldType.Json:
            case AnalysisConfigFieldType.StringTemplate:
                return 'object';
            default:
                return null; // Do not limit the schema.type for unknown types, useful for fields without a valid type defined
        }

    }

    public static getJsonEditorSchemaForAnalysisConfig(): AnalysisConfigJsonEditorSchema {
        return {
            type: 'object',
            required: ["type"],
            properties: {
                type: { type: "string" },
                description: { type: "string" }
            },
            additionalProperties: true
        };
    }

}
